import {
  BooksStage,
  BoxStage,
  DualityStage,
  KPKStage,
  NumbersStage,
  OscilloscopeStage,
  PanelkaStage,
  QuestDetails,
  QuestStar,
} from '@store'

import { QuestId } from '../store/quest/questId'

type CustomStage = Partial<
  Record<
    QuestId,
    {
      api?: (partId: number) => number | undefined
      store?: (
        questInfo: QuestDetails,
        availableStar: QuestStar[]
      ) => number | undefined
    }
  >
>

export const getCustomStageQuest: CustomStage = {
  [QuestId.Constellation]: {
    api: (partId: number) => {
      if (partId === 2) {
        return 1
      }
    },
  },
  [QuestId.Curve]: {
    api: (partId: number) => {
      if (partId === 2) {
        return 1
      }
    },
  },
  [QuestId.Box]: {
    store: (questInfo, availableStar) => {
      if (questInfo.currentStage === 4) {
        if (availableStar?.length > 0) {
          return BoxStage.Win
        }

        if (questInfo.solved) {
          return BoxStage.End
        }

        return BoxStage.BonusWin
      }
    },
  },
  [QuestId.Dots]: {
    api: (partId) => {
      if (partId === 2) {
        return 1
      }
    },
  },
  [QuestId.Changes]: {
    api: (partId) => {
      if (partId === 2) {
        return 1
      }
    },
  },
  [QuestId.Books]: {
    api: (partId: number) => {
      if (partId === 3 || partId === 4) {
        return 2
      }
    },
    store: (questInfo, availableStar) => {
      if (questInfo.currentStage === 2) {
        if (availableStar?.length > 0) {
          return BooksStage.BonusWin
        }

        if (questInfo.solved) {
          return BooksStage.End
        }

        return BooksStage.Bonus
      }
    },
  },
  [QuestId.KPK]: {
    api: (partId) => {
      if (partId === 6) {
        return 3
      }
      if (partId === 3) {
        return 2
      }
    },
    store: (questInfo, availableStar) => {
      if (
        questInfo.solved &&
        questInfo.currentStage >= 3 &&
        availableStar?.length === 0
      ) {
        return KPKStage.End
      }

      if (availableStar?.length || !questInfo.solution) {
        if (questInfo.currentStage === 3) {
          return KPKStage.BonusWin
        }
        return questInfo.currentStage
      }

      if (questInfo.currentStage === 3) {
        return questInfo.currentStage
      }
    },
  },
  [QuestId.Numbers]: {
    api: (partId: number) => {
      if (partId === 2) {
        return 1
      }
    },
    store: (questInfo, availableStar) => {
      if (questInfo.solved) {
        return NumbersStage.Win
      }

      if (!questInfo.solved && availableStar?.length === 0) {
        return NumbersStage.StartDialog
      }
    },
  },
  [QuestId.Panelka]: {
    api: (partId) => {
      if (partId === 3) {
        return 2
      }
    },
    store: (questInfo, availableStar) => {
      if (questInfo.currentStage === 2) {
        if (!questInfo.solved) {
          return PanelkaStage.Bonus
        }
        if (questInfo.solved && availableStar?.length > 0) {
          return PanelkaStage.BonusWin
        }
        if (questInfo.solved && availableStar?.length === 0) {
          return PanelkaStage.WinQuest
        }
      }
    },
  },
  [QuestId.Oscilloscope]: {
    api: (partId: number) => {
      if (partId === 2) {
        return 1
      }
    },
    store: (questInfo, availableStar) => {
      if (questInfo.solved) {
        return OscilloscopeStage.Win
      }

      if (!questInfo.solved && availableStar?.length === 0) {
        return OscilloscopeStage.StartDialog
      }
    },
  },
}
